import { useStore } from '../store';

const API_URL = 'https://api.elevenlabs.io/v1';
const VOICE_ID = 'z9fAnlkpzviPz146aGWa'; // Paola voice

export async function generateSpeech(text: string): Promise<ArrayBuffer> {
  const { apiKeys } = useStore.getState();
  
  if (!apiKeys?.elevenlabs) {
    throw new Error('ElevenLabs API key not configured');
  }

  const response = await fetch(`${API_URL}/text-to-speech/${VOICE_ID}/stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'xi-api-key': apiKeys.elevenlabs,
    },
    body: JSON.stringify({
      text,
      model_id: 'eleven_monolingual_v1',
      voice_settings: {
        stability: 0.71,
        similarity_boost: 0.85,
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`ElevenLabs API error: ${response.status}`);
  }

  return response.arrayBuffer();
}